var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            title: _vm.$t("Dados da Contagem"),
            "no-actions": "",
            "show-loading": _vm.busy || _vm.fetching,
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "status",
                      type: "label",
                      "is-badge": "",
                      label: _vm.$t("Status"),
                      options: _vm.stockCountingStatusOptions(),
                    },
                    model: {
                      value: _vm.stockCountingForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockCountingForm, "status", $$v)
                      },
                      expression: "stockCountingForm.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "store",
                      value: _vm.storeName,
                      type: "label",
                      label: _vm.$t("Loja"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "description",
                      type: "label",
                      label: _vm.$t("Descrição"),
                    },
                    model: {
                      value: _vm.stockCountingForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockCountingForm, "description", $$v)
                      },
                      expression: "stockCountingForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "percentCompleted",
                      label: _vm.$t("Perc. Completado"),
                      type: "label",
                      filter: "percentage",
                    },
                    model: {
                      value: _vm.stockCountingForm.percentCompleted,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockCountingForm, "percentCompleted", $$v)
                      },
                      expression: "stockCountingForm.percentCompleted",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "skusCount",
                      value: _vm.stockCountingForm.skusCount,
                      label: _vm.$t("Qtd. SKUs"),
                      type: "label",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "group",
                      value: _vm.groupName,
                      type: "label",
                      label: _vm.$t("Grupo"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "subgroup",
                      value: _vm.subgroupName,
                      type: "label",
                      label: _vm.$t("Subgrupo"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "brand",
                      value: _vm.brandName,
                      type: "label",
                      label: _vm.$t("Marca"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "department",
                      value: _vm.departmentName,
                      type: "label",
                      label: _vm.$t("Departamento"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "created-at",
                      value:
                        _vm.$options.filters.date(
                          _vm.stockCountingForm.createdDate
                        ) +
                        " / " +
                        (_vm.stockCountingForm.createdBy || "-"),
                      label: _vm.$t("Criado em / por"),
                      type: "label",
                    },
                  }),
                ],
                1
              ),
              _vm.stockCountingForm.deviationThresholdPercent != null
                ? _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "deviationThreshold",
                          value:
                            _vm.stockCountingForm.deviationThresholdPercent +
                            "%",
                          label: _vm.$t("Limite de desvio"),
                          type: "label",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.stockCountingForm.completedDate
        ? _c(
            "b-card-actions",
            {
              attrs: {
                title: _vm.$t("Dados da Finalização"),
                "no-actions": "",
                "show-loading": _vm.busy || _vm.fetching,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "completed_date",
                          value:
                            _vm.$options.filters.datetime(
                              _vm.stockCountingForm.completedDate
                            ) +
                            " / " +
                            (_vm.stockCountingForm.completedUser
                              ? _vm.stockCountingForm.completedUser.name
                              : "-"),
                          label: _vm.$t("Finalizado em / por"),
                          type: "label",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.stockCountingForm.cancelationDate
        ? _c(
            "b-card-actions",
            {
              attrs: {
                title: _vm.$t("Dados do Cancelamento"),
                "no-actions": "",
                "show-loading": _vm.busy || _vm.fetching,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "cancelation_date",
                          value:
                            _vm.$options.filters.datetime(
                              _vm.stockCountingForm.cancelationDate
                            ) +
                            " / " +
                            (_vm.stockCountingForm.cancelationUser
                              ? _vm.stockCountingForm.cancelationUser.name
                              : "-"),
                          label: _vm.$t("Cancelado em / por"),
                          type: "label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "cancelation_reason",
                          value: _vm.stockCountingForm.cancelationReason,
                          label: _vm.$t("Motivo"),
                          type: "label",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getSkus },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center flex-wrap",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
              _c("e-button", {
                staticClass: "ml-1 btn-sm-block",
                attrs: {
                  id: "download",
                  variant: "primary",
                  icon: "download",
                  busy: _vm.fetching,
                  text: _vm.$t("Baixar Relatório"),
                },
                on: { click: _vm.downloadReport },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "table-skus",
            staticClass: "mb-1 bordered",
            attrs: {
              "show-empty": "",
              striped: "",
              responsive: "",
              busy: _vm.busy,
              fields: _vm.fields,
              items: _vm.stockCountingSkus,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getSkus,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(name)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("e-product-router-link", {
                      attrs: {
                        "sku-id": item.skuId,
                        "product-id": item.productId,
                        "product-name": item.name,
                        ean: item.ean,
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(stockCounted)",
                fn: function (row) {
                  return [
                    _c(
                      "div",
                      { class: !_vm.readOnly ? "stock-counted-cell" : "" },
                      [
                        !_vm.readOnly && _vm.isInProgress && row.item.completed
                          ? _c("e-button", {
                              staticClass: "p-5",
                              attrs: {
                                icon: "trash",
                                variant: "danger",
                                title: _vm.$t("Excluir contagem"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetStockCounted(row.item)
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.readOnly
                          ? _c("FormulateInput", {
                              staticClass:
                                "text-right mb-0 stock-counted-input",
                              attrs: {
                                id: "sku-stock-counted-" + row.index,
                                type: "text-number",
                                precision: 3,
                              },
                              on: {
                                "blur-context": function ($event) {
                                  return _vm.updateStockCounted(row.item)
                                },
                              },
                              model: {
                                value: row.item.stockCounted,
                                callback: function ($$v) {
                                  _vm.$set(row.item, "stockCounted", $$v)
                                },
                                expression: "row.item.stockCounted",
                              },
                            })
                          : row.item.stockCounted != null
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("number")(
                                      row.item.stockCounted,
                                      3,
                                      true
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(stockInSystem)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    !_vm.canSeeStock
                      ? _c("span", [_vm._v("-")])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("number")(item.stockInSystem, 3, true)
                            )
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(stockDifference)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    !_vm.canSeeStock
                      ? _c("span", [_vm._v("-")])
                      : _c(
                          "span",
                          {
                            class: _vm.addValueOperationStyle(
                              item.stockDifference
                            ),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("number")(
                                    item.stockDifference,
                                    3,
                                    true
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                  ]
                },
              },
              {
                key: "cell(hasDivergence)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    !_vm.canSeeStock && !item.hasDivergence
                      ? _c("span", [_vm._v("-")])
                      : item.hasDivergence
                      ? _c(
                          "span",
                          { staticClass: "text-danger font-weight-bold" },
                          [_vm._v(" " + _vm._s(_vm.$t("Sim")) + " ")]
                        )
                      : item.hasDivergence === false
                      ? _c("span", { staticClass: "text-success" }, [
                          _vm._v(" " + _vm._s(_vm.$t("Não")) + " "),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "table-skus",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("stock-counting-cancel-modal", {
        ref: "cancelModal",
        on: { "after-confirm": _vm.onReturn },
      }),
      _c("fab", {
        attrs: {
          "main-tooltip": _vm.$t("Ações"),
          "main-icon": "keyboard_command_key",
          actions: _vm.actions,
          busy: _vm.busy,
        },
        on: {
          save: _vm.onFinishCounting,
          return: _vm.onReturn,
          cancel: _vm.onCancel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }